import { render, staticRenderFns } from "./ClickOnResourceModal.vue?vue&type=template&id=8affcc28"
import script from "./ClickOnResourceModal.vue?vue&type=script&lang=js"
export * from "./ClickOnResourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports